import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { AiWorkflowsBillingHistoryParams } from "@/react/helpers/urlHelpers/internalApi/aiWorkflowsBillingHistory";

export type { AiWorkflowsBillingHistoryParams };

export interface WorkflowBillingData {
  created_at: string;
  total_credits_consumed: number;
  total_overage_charges: number;
  total_runs: number;
  workflow_id: string;
  workflow_name: string;
}

export interface PaginationData {
  current_page: number;
  per_page: number;
  total_count: number;
  total_pages: number;
}

export interface AiWorkflowsBillingHistoryResponse {
  pagination: PaginationData;
  workflows: WorkflowBillingData[];
}

const fetchBillingHistoryData = (
  params: AiWorkflowsBillingHistoryParams,
): Promise<AiWorkflowsBillingHistoryResponse> =>
  reactQueryGet<AiWorkflowsBillingHistoryResponse>(
    internalApi.aiWorkflowsBillingHistory.list({ params }),
  );

export const aiWorkflowsBillingHistoryApi = {
  fetchBillingHistoryData,
};
